import { countries } from '../constants';

export const countryMap = (country) => ({
  itemValue: country.countryCode,
  itemLabel: country.countryName,
});
export const firMap = (fir) => ({
  itemValue: fir.firName,
  itemLabel: fir.firName,
});
export const countryCodeMap = (country) => ({
  itemValue: country.code,
  itemLabel: country.itemLabel,
});

export const waypointMap = (waypoint) => ({
  itemValue: waypoint.waypointName,
  itemLabel: waypoint.waypointName,
});

export const getCountryCode = (countryName) => {
  const countryCode = countries.filter(
    (country) => country.itemLabel.toUpperCase() === countryName,
  )[0]?.code;
  return countryCode;
};
export const getCountryName = (countryCode) => {
  const countryName = countries
    .filter((country) => country.code.toUpperCase() === countryCode)[0]
    ?.itemLabel.toUpperCase();
  return countryName;
};
